// extracted by mini-css-extract-plugin
export default {"portfolio":"_2wXGi","portfolio_group":"_2a15W","logoImg":"_2PIUn","company_logo":"qDLtx"};